import { Paper } from "@mui/material"
import { StudentNoteTable } from "./components/StudentNoteTable"
type StudentNoteTableProps = {
    onBack?: () => void
}
const StudentNoteTablePage = ({ onBack }: StudentNoteTableProps) => {
    return (
        <Paper>
            <StudentNoteTable onBack={onBack} />
        </Paper>
    )
}

export default StudentNoteTablePage